import './Checkbox.scss';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

// Common Checkbox Component
const Checkbox = ({ selected, handleClick, label }) => {
  return (
    <div
      className={`checkbox ${selected ? 'selected' : ''}`}
      data-testid={`checkbox_${label}`}
      key={`checkbox_${label}`}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faCheck} className="package_checkbox_icon" />
    </div>
  );
};

Checkbox.propTypes = {
  selected: PropTypes.bool,
  handleClick: PropTypes.func,
  label: PropTypes.string,
};

export default Checkbox;
